/* One explicit cart action, retaining the line's quantity and properties. */
(() => {
  let busy = false;
  const root = window.Shopify?.routes?.root || '/';
  async function request(path, body) {
    if (path === 'cart/add.js' && body?.items && window.formthrPreorder) body.items.forEach(item => { item.properties = {...window.formthrPreorder.properties, ...item.properties}; });
    const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
    return data;
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-upgrade], [data-cart-cross-sell]');
    if (!button || busy) return;
    busy = true; button.disabled = true;
    const label = button.innerHTML, panel = button.closest('[data-cart-offer]'), error = panel.querySelector('[role="alert"]');
    error.hidden = true; button.textContent = 'Updating…';
    try {
      const cart = await request('cart.js');
      const rendering = {sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname};
      let data;
      if (button.hasAttribute('data-cart-upgrade')) {
        const index = cart.items.findIndex(item => item.key === button.dataset.key);
        if (index < 0) throw new Error('Your cart changed. Please reopen it and try again.');
        const gifts = [Number(button.dataset.frother), Number(button.dataset.tote)].filter(Boolean);
        if (gifts.length !== 2) throw new Error('The gift offer is temporarily unavailable. Please try again shortly.');
        let missing = [];
        let parentKey;
        const original = cart.items[index];
        let upgraded = false;
        try {
          const convertedCart = await request('cart/change.js',{line:index+1,quantity:original.quantity,selling_plan:Number(button.dataset.plan)});
          upgraded = true;
          const parent = convertedCart.items.find(item => item.variant_id === original.variant_id && item.selling_plan_allocation?.selling_plan.id === Number(button.dataset.plan));
          if (!parent) throw new Error('We could not find the upgraded subscription. Please try again.');
          parentKey = parent.key;
          missing = gifts.filter(id => !convertedCart.items.some(item => item.variant_id === id && item.parent_relationship?.parent_key === parentKey));
          if (missing.length) await request('cart/add.js',{items:missing.map(id => ({id,quantity:1,parent_line_key:parent.key}))});
          // Use the same configured gift promotion as the product buy box.
          await fetch(root + 'discount/FreeGift', {redirect:'manual'});
          const verified = await request('cart.js');
          if (!gifts.every(id => verified.items.some(item => item.variant_id === id && item.parent_relationship?.parent_key === parentKey && item.final_line_price === 0))) {
            throw new Error('We could not apply the free-gift offer. Please try again.');
          }
          data = verified;
        } catch (giftError) {
          // Never leave newly added gifts in the cart at a paid price after a failed upgrade.
          if (upgraded) {
            const latest = await request('cart.js');
            const updates = {};
            latest.items.filter(item => missing.includes(item.variant_id) && item.parent_relationship?.parent_key === parentKey).forEach(item => { updates[item.key] = 0; });
            if (Object.keys(updates).length) await request('cart/update.js',{updates});
            // Restore only the converted quantity if Shopify merged it with an existing subscription.
            const current = await request('cart.js');
            const converted = current.items.find(item => item.variant_id === original.variant_id && item.selling_plan_allocation?.selling_plan.id === Number(button.dataset.plan));
            if (converted) {
              if (converted.quantity > original.quantity) {
                await request('cart/change.js',{id:converted.key,quantity:converted.quantity-original.quantity});
                await request('cart/add.js',{items:[{id:original.variant_id,quantity:original.quantity,properties:original.properties}]});
              } else await request('cart/change.js',{id:converted.key,quantity:original.quantity,selling_plan:null});
            }
          }
          throw giftError;
        }
      } else {
        if (cart.items.some(item => item.variant_id === Number(button.dataset.variant))) throw new Error('This item is already in your cart.');
        data = await request('cart/add.js',{items:[{id:Number(button.dataset.variant),quantity:1}],...rendering});
      }
      if (!data.sections?.['cart-drawer']) {
        const sections = await request('?sections=cart-drawer,cart-icon-bubble');
        data.sections = sections;
      }
      document.querySelector('cart-drawer').renderContents(data);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'mthr-cart-offer',cartData:data});
    } catch (e) {
      error.textContent = e.message || 'Unable to update your cart. Please try again.'; error.hidden = false;
      button.innerHTML = label; button.disabled = false;
    } finally { busy = false; }
  });
})();
